export default __webpack_public_path__ + "static/media/img-bd.3db638f4.svg";